import React, { useState } from 'react';
import { Link, Redirect, RouteComponentProps } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import { TextField, Button, Typography, Box, Grid, styled, Select, InputLabel, MenuItem, Paper, Snackbar, Alert } from '@mui/material';
// import BasicModal from './CongratsModal'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { formFields } from './SignupFields';
import BasicModal from '../CongratsModal';
// import { FormField } from './SignupFields';
import { schema } from './signupSchema';
import { FormField, UserDetails } from '../types/form';

const SimpleTextField = styled(TextField)(({ theme }) => ({
    ".MuiFormLabel-root": {
        right: "15px",
        textAlign: "right",
        direction: "rtl",
        left: 'unset',
        paddingRight: '5px'
    },
    'fieldset': {
        textAlign: 'right'
    },
    "input": {
        textAlign: 'right',
    },
    '.MuiFormLabel-asterisk': {
        color: 'red !important'
    }
}))

interface SignupProps extends RouteComponentProps {
  onSignup: (userData: UserDetails) => void;
  error?: string;
  onErrorClear: () => void;
}

const Signup: React.FC<SignupProps> = ({ onSignup, error, onErrorClear }) => {
    const {
        register,
        handleSubmit,
        watch,
        getValues,
        control,
        formState: { errors, isValid } } = useForm<UserDetails>({
            defaultValues: {
                street: '',
                area: '',
                floor: '',
                city: '',
                government: '',
                buildingNo: '',
                apartmentNo: '',
                others: '',
                name: '',
                email: '',
                category: 'family',
                phone: '',
                password: '',
                business_activity: undefined
            },
            resolver: yupResolver(schema)
        })
    const values = watch()
    const [open, setOpen] = useState(false)
    const [snackbarOpen, setSnackbarOpen] = useState(false)
    const [snackbarMessage, setSnackbarMessage] = useState('')

    React.useEffect(() => {
        if (error) {
            setSnackbarMessage(error)
            setSnackbarOpen(true)
        } else {
            setSnackbarOpen(false)
            setSnackbarMessage('')
        }
    }, [error])

    const handleSnackbarClose = () => {
        setSnackbarOpen(false)
        setSnackbarMessage('')
        onErrorClear()
    }

    const onSubmit = (data: UserDetails, e: any) => {
        e.preventDefault()
        onSignup(data)
        console.log(data)
        // setOpen(true)
    };

    const renderField = (field: FormField) => {
        if (field.conditional && !field.conditional(values)) {
            return null;
        }

        const commonProps = {
            label: field.label,
            required: field.required,
            fullWidth: true,
            error: !!errors[field.name],
            helperText: errors[field.name]?.message,
            ...register(field.name),
            slotProps: {
                inputLabel: {
                    sx: { textAlign: 'right', direction: 'rtl' }
                }
            }
        };

        switch (field.type) {
            case 'radio':
                return (
                    <Controller
                        key={field.name}
                        control={control}
                        name={field.name}
                        render={({ field: radioField }) => (
                            <FormControl>
                                <FormLabel sx={{ fontSize: 20, fontWeight: 700 }}>{field.label}</FormLabel>
                                <RadioGroup row defaultValue={'family'} {...radioField}>
                                    {field.options?.map((option: { value: string; label: string }) => (
                                        <FormControlLabel 
                                            key={option.value} 
                                            value={option.value} 
                                            control={<Radio />} 
                                            label={option.label} 
                                        />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        )}
                    />
                );

            case 'select':
                return (
                    <Controller
                        key={field.name}
                        control={control}
                        name={field.name}
                        render={({ field: selectField }) => (
                            <FormControl fullWidth>
                                <FormLabel>{field.label}</FormLabel>
                                <Select {...selectField}>
                                    {field.options?.map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}
                    />
                );

            case 'textarea':
                return (
                    <SimpleTextField
                        key={field.name}
                        {...commonProps}
                        multiline={field.multiline}
                        rows={field.rows}
                        slotProps={{
                            ...commonProps.slotProps,
                            input: {
                                inputProps: {
                                    style: { textAlign: 'right' }
                                }
                            }
                        }}
                    />
                );

            default:
                return (
                    <SimpleTextField
                        key={field.name}
                        {...commonProps}
                        type={field.type}
                    />
                );
        }
    };
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: '#f5f5f5',
      }}
    >
      <Paper elevation={3} sx={{ maxWidth: 800, mx: 'auto', mt: 4, textAlign: 'center', display: 'flex', flexDirection: 'column', p: 4 }}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Typography variant="h4" gutterBottom>
                    أدخل البيانات الخاصة بتوصيل الطلب اليك
                </Typography>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    {formFields.map((field: FormField) => (
                        <Grid item xs={field.gridSize} key={field.name}>
                            {renderField(field)}
                        </Grid>
                    ))}
                </Grid>

                <Button
                    variant="contained"
                    color="primary"
                    type='submit'
                    sx={{ mb: 2 }}
                >
                    Submit
                </Button>
            </form>
            {/* <BasicModal open={open} handleClose={() => {
                setOpen(false);
                window.location.reload()
            }} /> */}
            <Box sx={{ my: 2 }}>
                <Link to="/login">
                    <Typography variant="body2">
                        لديك حساب بالفعل؟ تسجيل الدخول
                    </Typography>
                </Link>
            </Box>
            <Snackbar 
                open={snackbarOpen} 
                autoHideDuration={6000} 
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleSnackbarClose} severity="error" sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Paper>
    </Box>
  );
};

export default Signup; 